/**
 * Распределительная коробка на чертеже — узел, куда сходятся кабели.
 *
 * Тёмная подложка с толстой рамкой: на плане коробка одна-две на квартиру, и она
 * должна быть заметнее розеток — от неё пользователь начинает вести проводку.
 * «Не подключена» для коробки не рисуется: подключают к ней, а не её.
 */
import { CatalogSymbol } from "../../CatalogSymbol";
import type { ElementShapeProps } from "./ElectricalItemShape";
import { ItemFrame, SELECTED_COLOR } from "./ItemFrame";

export const JunctionBoxShape = ({
	fixture,
	item,
	width,
	height,
	color,
	selected,
	...frame
}: ElementShapeProps) => {
	const px = (n: number) => n * frame.mmPerPx;
	const stroke = selected ? SELECTED_COLOR : color;
	return (
		<ItemFrame
			{...frame}
			unconnected={false}
			fixtureId={fixture.id}
			width={width}
			height={height}
			color={color}
			selected={selected}
			backdrop={
				<rect
					x={-width / 2}
					y={-height / 2}
					width={width}
					height={height}
					rx={px(2)}
					fill="#f1f5f9"
					stroke={stroke}
					strokeWidth={px(1.6)}
				/>
			}
		>
			<CatalogSymbol
				item={item}
				width={width}
				height={height}
				color={stroke}
				mmPerPx={frame.mmPerPx}
			/>
		</ItemFrame>
	);
};
